import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MentoringAdvisingComponent } from './mentoring-advising.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: MentoringAdvisingComponent,
    data: {
      title: "Mentoring Advising",
      breadcrumb: "Mentoring Advising"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class MentoringAdvisingRoutingModule { }